import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { useVersionCheck } from '~/hooks/useVersionCheck';

export function VersionUpdateBanner() {
  const updateAvailable = useVersionCheck();
  const shown = useRef(false);

  useEffect(() => {
    if (!updateAvailable || shown.current) return;
    shown.current = true;
    toast.warning('Update available', {
      duration: Infinity,
      closeButton: true,
      action: {
        label: 'Refresh',
        onClick: () => window.location.reload(),
      },
    });
  }, [updateAvailable]);

  return null;
}
